export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="w-full rounded-[24px] overflow-hidden relative h-[250px] md:h-[340px]">
          <img
            src="https://readdy.ai/api/search-image?query=Luxurious%20fashion%20display%20with%20premium%20handbag%20designer%20shoes%20and%20silk%20scarf%20arranged%20on%20a%20glossy%20white%20pedestal%2C%20dramatic%20studio%20lighting%20with%20soft%20spotlights%2C%20high%20end%20boutique%20window%20display%20aesthetic%2C%20reflective%20surfaces%2C%20elegant%20luxury%20vibe%2C%20champagne%20gold%20accents%2C%20editorial%20fashion%20photography&width=1600&height=600&seq=cta-banner-v2-01&orientation=landscape"
            alt="OOPBuy product showcase"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-4 border border-white/20 rounded-[16px] pointer-events-none"></div>
        </div>

        <div className="text-center mt-10">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-950 font-heading leading-[1.15]">
            Start Your
            <br />
            <span className="font-display italic font-medium text-foreground-600">
              OOPBuy Journey
            </span>
            <br />
            With Structured Data
          </h2>

          <p className="mt-5 text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto leading-relaxed">
            Stop guessing and start using structured data to improve your dropshipping results. Explore the full OOPBuy platform today.
          </p>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center justify-center h-[60px] px-10 rounded-full bg-foreground-950 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now on Kaspreadsheet
          </a>
        </div>
      </div>
    </section>
  );
}